import { Controller } from "@hotwired/stimulus";
import { useEmitter } from "@/emitter"
import { enter, leave } from "@/el-transition"

export default class extends Controller {
    static targets = [
        'line',
    ]

    prevScroll = (window.scrollY || document.scrollTop)
    direction = 0
    prevDirection = 0

    connect() {
        useEmitter(this)

        // useTransition(this, {
        //     element: this.listTarget,
        //     enterActive: "transition ease-out duration-300",
        //     enterFrom: "transform opacity-0 -translate-y-3/4",
        //     enterTo: "transform opacity-100 translate-0",
        //     leaveActive: "transition ease-in duration-300",
        //     leaveFrom: "transform opacity-100 translate-0",
        //     leaveTo: "transform opacity-0 -translate-y-3/4",
        //     hiddenClass: 'hidden',
        //     // set this, because the item *starts* in an open state
        //     // transitioned: true,
        // })

        // addEventListener('scroll', this.handle.bind(this))
    }

    handle() {
        const curScroll = window.scrollY || document.scrollTop

        if (curScroll > this.prevScroll) {
            this.direction = 2;
        } else if (curScroll < this.prevScroll) {
            this.direction = 1;
        }

        if (this.direction !== this.prevDirection) {
            this.toggleHeader(curScroll);
        }

        this.prevScroll = curScroll
    }

    toggleHeader(curScroll) {
        if (this.direction === 2 && curScroll > this.lineTarget.offsetHeight) {
            leave(this.element, 'header', 'hidden');
            this.prevDirection = this.direction;
        } else if (this.direction === 1) {
            enter(this.element, 'header', 'hidden');
            this.prevDirection = this.direction;
        }
    }

    disconnect() {
        this.$clear()
        // removeEventListener('scroll', this.handle.bind(this))
    }

    close() {
        this.closeSide();
        this.buttonToggle()
    }

    hide(event) {
        // @ts-ignore
        // if (!this.element.contains(event.target) && !this.listTarget.classList.contains('hidden')) {
        //   this.leave()
        // }
        // this.buttonToggle()
    }

    toggle() {
        this.toggleTransition()
        this.buttonToggle()
    }

    toggleSide() {
        this.$emit('menu:open')
    }

    closeSide() {
        this.$emit('menu:close')
    }

    buttonToggle() {
        if (this.hasButtonTarget) {
            this.buttonTarget.classList.toggle('active', this.transitioned)
        }
    }
}
